<template>
  <div class="services-accordion--wrapper">
    <Title
      :text="labels.selectServicesTitle"
      size="tertiary"
      color="black"
      class="title"
      v-if="optionalServicesAccordion && optionalServicesAccordion.length"
    ></Title>
    <div v-if="shouldShowServices && servicesAccordions.length">
      <div
        v-for="serviceAccordion in regularServicesAccordions"
        :key="serviceAccordion.option.priceCategoryId"
      >
        <ServiceAccordion
          :is-service-accordion-open="serviceAccordion.isOpen"
          :is-selected="serviceAccordion.isSelected"
          :header-text="serviceAccordion.option.title"
          :service-name="serviceAccordion.option.name"
          :text-content="serviceAccordion.option.description"
          :select-service="() => selectService(serviceAccordion.option)"
          :isDisabled="isDisabled"
          @toggleServiceAccordion="
            () => toggleServiceAccordion(serviceAccordion.option.id)
          "
        ></ServiceAccordion>
      </div>
      <div v-if="optionalServicesAccordion && optionalServicesAccordion.length">
        <div class="titles">
          <Title
            :text="labels.premiumServicesTitle"
            size="tertiary"
            color="black"
            class="title"
          ></Title>
          <Title
            :text="labels.premiumServicesTitleDescription"
            size="small"
            color="gray__darkest"
          >
          </Title>
        </div>
        <div
          v-for="serviceAccordion in optionalServicesAccordion"
          :key="serviceAccordion.option.priceCategoryId"
        >
          <ServiceAccordion
            :is-service-accordion-open="serviceAccordion.isOpen"
            :is-selected="serviceAccordion.isSelected"
            :header-text="serviceAccordion.option.title"
            :text-content="serviceAccordion.option.description"
            :select-service="() => selectService(serviceAccordion.option)"
            @toggleServiceAccordion="
              () => toggleServiceAccordion(serviceAccordion.option.id)
            "
            :isDisabled="isDisabled"
          ></ServiceAccordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceAccordion from '@/components/Booking/Services/ServiceAccordion.vue';
import Title from '@/components/shared/Title.vue';
export default {
  name: 'Services',
  components: { ServiceAccordion, Title },
  props: {
    toggleServiceAccordion: { type: Function },
    servicesAccordions: { type: Array, default: () => [] },
    selectedServices: { type: Array, default: () => [] },
    selectService: { type: Function },
    shouldShowServices: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptionalServiceTitleVisible: { type: Boolean, default: true },
    labels: { type: Object, default: () => {} }
  },
  computed: {
    regularServicesAccordions() {
      return this.servicesAccordions.filter(
        perfAcc => !perfAcc.isOptional && perfAcc.isVisible
      );
    },
    optionalServicesAccordion() {
      return this.servicesAccordions.filter(
        perfAcc => perfAcc.isOptional && perfAcc.isVisible
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.titles {
  display: flex;
  align-items: center;
  margin-top: 50px;
  .title:first-child {
    margin-right: 5px;
  }
}
.placeholder {
  display: flex;
  align-items: center;
  & > :first-child {
    margin-right: 8px;
  }
}
</style>
